
import { api } from '../store/middleware/api'

const extendedApi = api.injectEndpoints({
    endpoints : (build) => ({
        getAllMealPlan: build.query({
            query:(body) => ({
                url:"/mealplane/get",
                body
            })
        }),
        getMealPlanById: build.query({
            query:(id) => `/mealplane/get/${id}`,
        }),
        getDishesByMealplan: build.query({
            query:(id) => `/dish/mealplan/${id}`,
        })
    })
})

export const { useGetAllMealPlanQuery, useGetMealPlanByIdQuery, useGetDishesByMealplanQuery } = extendedApi 